webpackJsonp([115845867630254],{

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graphql = __webpack_require__(8);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template() {
	  // export default function Template({ data }) {
	  // const { markdownRemark: post, allFile } = data;
	  // const imagesArray = [];
	  // allFile.edges.map(({ node: file }) => imagesArray.push(file));
	  // return (
	  //   <div>
	  //     <Helmet title={`About Us | ${data.site.siteMetadata.title}`} />
	  //     <section>
	  //       <h1>{post.frontmatter.title}</h1>
	  //       <div dangerouslySetInnerHTML={{ __html: post.html }} />
	  //     </section>
	  //     {post.frontmatter.members && (
	  //       <section>
	  //         {post.frontmatter.members.map((member, i) => (
	  //           <div xs="12" sm="6" md="2" key={i}>
	  //             {imagesArray
	  //               .filter(item => item.relativePath === member.photo.slice(14))
	  //               .map((item, j) => <Img key={j} resolutions={item.childImageSharp.resolutions} />)}
	  //             <h2>{member.fullname}</h2>
	  //             <h3>{member.position}</h3>
	  //           </div>
	  //         ))}
	  //       </section>
	  //     )}
	  //   </div>
	  // );
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'hero pb-80' },
	      _react2.default.createElement(
	        'div',
	        { className: 'StripeBackground accelerated' },
	        _react2.default.createElement('div', { className: 'stripe s0' }),
	        _react2.default.createElement('div', { className: 'stripe s1' }),
	        _react2.default.createElement('div', { className: 'stripe s2' }),
	        _react2.default.createElement('div', { className: 'stripe s3' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body is-clean container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container mt-100 pt-80 pb-40' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'is-size-2 mb-10 section-title' },
	              'Our mission is to increase your potential'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'is-size-3-5 mt-10 ml-auto mr-auto mb-60', style: { maxWidth: '800px' } },
	              'Next Software is a technology company that builds infrastructure for the companies. Businesses of every size\u2014from new startups to public companies\u2014use our services to build and manage their businesses online.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'pt-60 pb-60 bg-white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container mt-60' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-9' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'mb-10' },
	                'Excellent administration & attainment'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'The main focus of our team is to solve your problems quickly and effectively and ensuring that your project is completed on time and that too with minimum budget possible.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-3 mt-10' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar short-points' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle is-size-4 color-reactjs' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Performance review'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar short-points' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle is-size-4 color-reactjs' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Improvement Plan'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-9' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'mb-10' },
	                'Evolve in our area'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Next not only provides access to best resources but also renew it',
	                '\'',
	                's technology from time to time to provide you with best outcomes.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-3 mt-10' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar short-points' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle is-size-4 color-reactjs' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Performance review'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar short-points' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle is-size-4 color-reactjs' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Improvement Plan'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-9' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'mb-10' },
	                'Perfect tools for the right job'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Our engineers know how difficult it is to work with new tools and technologies each and every time, so we make sure that including our team, you are also updated regarding each and every tool and technology.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-3 mt-10' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar short-points' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle is-size-4 color-reactjs' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Performance review'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar short-points' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-check-circle is-size-4 color-reactjs' })
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Improvement Plan'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'pt-60 pb-60' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'is-size-3 mb-10 font-w-400' },
	              'Solutions rooted in code and architecture'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'is-size-4 mt-10 ml-auto mr-auto mb-60', style: { maxWidth: '800px' } },
	              'As the world\u2019s leading service provider, Next Software gives businesses the tools and technology to build better.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-6' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-book is-size-4 color-primary' })
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Hassle-free development'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We develop a web product only using the latest technologies removing the scope of chaos and providing you with a user friendly web product.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-book is-size-4 color-primary' })
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Boost team strength'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'It is not possible for every team to have members specialised in every field. We provide you those team members which you are lacking in your team for the development of your product.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar rooted-pillar--oss' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-github is-size-4 color-primary' })
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Team nurturing and guidance'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We train your team over web and on-site too, depending on the needs of your team. Our training in testing and optimization can enhance your team',
	                '\'',
	                's skills without slowing down the process of development.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'rooted-pillar rooted-pillar--works-with' },
	              _react2.default.createElement(
	                'figure',
	                { 'aria-hidden': 'true' },
	                _react2.default.createElement('i', { className: 'fa fa-css3 is-size-4 color-primary' })
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Finding loopholes'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                ' We not only find loopholes in your product but also give you solutions and help you fix it. '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-offset-1 is-5' },
	            _react2.default.createElement(
	              'section',
	              { className: 'blog-posts-container relative' },
	              _react2.default.createElement(
	                'div',
	                { className: 'columns' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column is-9' },
	                  _react2.default.createElement(
	                    'article',
	                    { className: 'blog-post-card with-hero-image columns' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/blog/second-blog', className: 'column is-5 text-cont' },
	                      _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Architecture at scale'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'blog-card-summary' },
	                        'With offline capabilties and app like installs, you can reach your customer like never before.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'column is-7 img-cont' },
	                      _react2.default.createElement('img', { alt: 'High Tide Progressive Web App', src: '/files/images/new/high-tide-progressive-web-app.jpg', className: 'card__img-wrap__img' })
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/docs', className: 'read-more-link is-size-6' },
	                      'Read more ',
	                      _react2.default.createElement('i', { className: 'ml-5 fa fa-arrow-right' })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	// import Img from 'gatsby-image';
	// import Helmet from 'react-helmet';
	
	
	Template.propTypes = {
	  data: _propTypes2.default.object
	};
	
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-us-old-jsx-38d40d4afa5fd97074aa.js